export default {
  'Better in treatment group': 'rgb(255, 111, 44)',
  'Worse in treatment grouo': 'rgb(208, 240, 253)',
}
